/* eslint-disable */
export default {
  _rifficregular: 'rifficregular',
}